import { jsx } from 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';
import { Breadcrumbs as Breadcrumbs$1 } from 'baseui/breadcrumbs';
import { mergeOverrides } from '../../overrides.js';
import { IconDot } from './dot.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function getStyles({ element }) {
  switch (element) {
    case "Icon": {
      return {
        width: "4px",
        height: "4px"
      };
    }
    case "Root":
    default:
      return {
        color: "inherit"
      };
  }
}
const Breadcrumbs = (_a) => {
  var _b = _a, { overrides, $style } = _b, props = __objRest(_b, ["overrides", "$style"]);
  const resolvedStyles = useResolvedStyle($style);
  return jsx(Breadcrumbs$1, __spreadValues({ overrides: mergeOverrides({
    Root: {
      style: mergeStyles(getStyles({ element: "Root" }), resolvedStyles)
    },
    Icon: {
      props: {
        style: getStyles({ element: "Icon" }),
        overrides: {
          Svg: IconDot
        }
      }
    }
  }, overrides) }, props));
};

export { Breadcrumbs };
